import React from "react";
import { useNavigate } from "react-router-dom";
import "./Calendar2026.css";
import RaceTrack from "../components/RaceTrack";
import f1Calendar2026 from '../data/f1-calendar-2026.json';

const Calendar2026 = () => {
  const navigate = useNavigate();
  const races = f1Calendar2026.MRData.RaceTable.Races;

  return (
    <div className="calendar-2026-page">
      {/* Navigation Bar */}
      <nav className="calendar-navbar">
        <div className="navbar-container">
          <div className="navbar-logo" onClick={() => navigate('/')}>
            <span className="logo-icon">🏎️</span>
            <span className="logo-text">F1 Fantasy</span>
          </div>
          <div className="navbar-actions">
            <button className="nav-btn nav-btn-back" onClick={() => navigate('/')}>
              ← Back to Home
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div className="calendar-hero">
        <div className="calendar-hero-content">
          <div className="hero-badge">
            <span className="badge-icon">🏆</span>
            <span>Provisional Calendar</span>
          </div>
          <h1 className="calendar-hero-title">
            2026 F1 Season
            <br />
            <span className="gradient-text">Race Calendar</span>
          </h1>
          <p className="calendar-hero-subtitle">
            24 Races • 6 Sprint Weekends • New Era Begins
          </p>
          <div className="calendar-stats">
            <div className="calendar-stat-item">
              <div className="stat-number">24</div>
              <div className="stat-label">Grand Prix</div>
            </div>
            <div className="stat-divider"></div>
            <div className="calendar-stat-item">
              <div className="stat-number">6</div>
              <div className="stat-label">Sprint Races</div>
            </div>
            <div className="stat-divider"></div>
            <div className="calendar-stat-item">
              <div className="stat-number">Mar-Dec</div>
              <div className="stat-label">2026</div>
            </div>
          </div>
        </div>
      </div>

      {/* Calendar Section */}
      <section className="calendar-content-section">
        <div className="section-container">
          <div className="calendar-info-cards">
            <div className="info-card">
              <div className="info-icon">⚡</div>
              <h3>Sprint Weekends</h3>
              <p>6 Sprint races in China, Miami, Belgium, USA, Brazil & Qatar</p>
            </div>
            <div className="info-card">
              <div className="info-icon">🏁</div>
              <h3>New Regulations</h3>
              <p>Major technical changes with new power units and aerodynamics</p>
            </div>
            <div className="info-card">
              <div className="info-icon">🌍</div>
              <h3>Global Tour</h3>
              <p>24 races across 5 continents spanning 9 months</p>
            </div>
          </div>

          <RaceTrack races={races} />

          <div className="calendar-cta-section">
            <h2 className="cta-title">Ready for the 2026 Season?</h2>
            <p className="cta-subtitle">
              Start building your fantasy team now and be ready when the season kicks off!
            </p>
            <button className="cta-btn cta-primary" onClick={() => navigate('/signup')}>
              <span>Create Your Team</span>
              <span className="btn-icon">→</span>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="calendar-footer">
        <div className="footer-container">
          <p>&copy; 2025 F1 Fantasy League. Calendar subject to FIA approval.</p>
          <button className="footer-link" onClick={() => navigate('/')}>
            Back to Home
          </button>
        </div>
      </footer>
    </div>
  );
};

export default Calendar2026;

